export var Alignment;
(function (Alignment) {
    Alignment["Left"] = "left";
    Alignment["Center"] = "center";
    Alignment["Right"] = "right";
})(Alignment || (Alignment = {}));
//# sourceMappingURL=ISpan.js.map